import { RedirectPaths, RedirectPathsEnum } from '@/common/constants';
import classNames from 'classnames';
import { MenuItem } from 'primereact/menuitem';
import { TabMenu } from 'primereact/tabmenu';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

const getItemTemplate = (url: string, current: string) => (item: MenuItem) =>
  (
    <Link
      to={url}
      className={classNames({
        'p-menuitem-link': true,
        'p-menuitem-link-active': current.includes(url),
      })}
      role="menuitem"
    >
      <span className="p-menuitem-text">{item.label}</span>
    </Link>
  );

export const ResellerTabs = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const getMenuItems = (): MenuItem[] => {
    const items: MenuItem[] = [
      {
        label: t('resellers.list'),
        template: getItemTemplate(
          RedirectPaths[RedirectPathsEnum.RESELLERS](),
          location.pathname,
        ),
        data: RedirectPaths[RedirectPathsEnum.RESELLERS](),
      },
      {
        label: t('resellers.platformSettings'),
        template: getItemTemplate(
          RedirectPaths[RedirectPathsEnum.RESELLERS_SYSTEM](),
          location.pathname,
        ),
        data: RedirectPaths[RedirectPathsEnum.RESELLERS_SYSTEM](),
      },
    ];

    return items;
  };

  const items = getMenuItems();
  const paths = items.map((item) => item.data);
  const currentPath = location.pathname;
  const [activeIndex, setActiveIndex] = useState<number>(
    paths.indexOf(currentPath),
  );

  return (
    <TabMenu
      model={items}
      activeIndex={activeIndex}
      onTabChange={(e) => setActiveIndex(e.index)}
    />
  );
};
